/*
 *
 * Navigation constants
 *
 */

export const TOGGLE_MENU = 'src/Navigation/TOGGLE_MENU';